"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
export function createDecreasePositionStep(txRequest) {
  return {
    type: TransactionStepType.DecreasePositionTransaction,
    txRequest
  };
}
export function createDecreasePositionStepBatched(batchedTxRequests, fallbackSteps) {
  return {
    type: TransactionStepType.DecreasePositionTransactionBatched,
    batchedTxRequests,
    fallbackSteps
  };
}
